'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdLocationOff = function MdLocationOff(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm19.5 19.1c4.7 4.6 9.3 9.2 13.9 13.8l-2.1 2.1-5.7-5.5c-2.8 4.1-5.6 7.1-5.6 7.1s-11.6-12.8-11.6-21.6c0-0.9 0.1-1.7 0.3-2.6l-5.3-5.3 2.1-2.1 13.9 13.9z m0.5-8.2c-1.2 0-2.3 0.5-3 1.4l-5.4-5.3c2.1-2.2 5.1-3.6 8.4-3.6 6.5 0 11.6 5.1 11.6 11.6 0 2.8-1.1 6-2.8 9.1l-6-6.1c0.9-0.7 1.3-1.7 1.3-3 0-2.3-1.8-4.1-4.1-4.1z' })
        )
    );
};

exports.default = MdLocationOff;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/location-off.js
// module id = 3072
// module chunks = 0